import React from 'react';
import Select from 'react-select';

const MultiSelect = ({...props}) => {
  return(
    <Select
    multi={true}
    value={props.selectedChannelAdministrators}
    onChange={ (input) => props.input.onChange(input) }
    options={props.options}
    {...props}
    />
  )
}

export default MultiSelect;

